module.exports = __webpack_public_path__ + "static/inconsolata-latin-700.7c01930d.woff";


//////////////////
// WEBPACK FOOTER
// ./~/typeface-inconsolata/files/inconsolata-latin-700.woff
// module id = ./node_modules/typeface-inconsolata/files/inconsolata-latin-700.woff
// module chunks = 17241999800008180000